import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ValueStack() {
  return <section id="pricing" className="py-16 md:py-24 px-4 bg-card/50" data-id="element-108">
      <div className="max-w-4xl mx-auto" data-id="element-109">
        <div className="text-center mb-12" data-id="element-110">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-main mb-4" data-id="element-111">
            Esto es lo que vas a recibir hoy mismo:
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="bg-base border border-warm/20 rounded-xl p-8 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-8 mb-12" data-id="element-112">
          <div className="bg-warm/10 p-6 rounded-full text-warm shrink-0" data-id="element-113">
            <BookOpenIcon size={40} data-id="element-114" />
          </div>
          <div className="flex-1 text-center md:text-left" data-id="element-115">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-main mb-2" data-id="element-116">
              Mente en Calma
            </h3>
            <p className="text-muted text-base md:text-lg leading-relaxed" data-id="element-117">
              El método paso a paso de 7 días que usa la neurociencia y el
              biohacking para enviarle una señal química a tu cerebro de que el
              peligro ha pasado. Sin vueltas. Sin teoría aburrida. Solo
              protocolos que funcionan en 5 minutos o menos.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-gradient-to-b from-base to-card border border-warm/30 rounded-2xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-118">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-warm to-transparent" data-id="element-119"></div>

          <div id="price-zone" className="mb-6" data-id="element-120">
            <p className="text-sm font-bold text-urgent uppercase tracking-widest mb-4" data-id="element-121">
              Oferta por tiempo limitado
            </p>
            <h3 className="text-5xl md:text-6xl font-serif font-bold text-warm mb-8" data-id="element-122">
              ARS 9.500
            </h3>
          </div>

          <CTAButton className="w-full md:w-auto md:px-12 md:py-6 text-lg" data-id="element-123" />

          <p className="mt-6 text-sm text-muted flex items-center justify-center gap-2" data-id="element-124">
            <span className="w-2 h-2 rounded-full bg-urgent animate-pulse" data-id="element-125"></span>
            Cupos limitados disponibles a este precio
          </p>
        </motion.div>
      </div>
    </section>;
}